import {observer} from "mobx-react";
import * as React from "react";
import {useNavigate} from "react-router-dom";
import {Box, Collapse, Typography, useTheme} from "@mui/material";
import {useApplication} from "../../../../ApplicationProvider";
import {useNavigatorFeature} from "../../../../useFeature";
import PortfolioAgingFeature from "./PortfolioAgingFeature";
import AgingTierCard from "./AgingTierCard";
import StackedAgingBar from "./StackedAgingBar";
import TopDebtorsHeader from "./TopDebtorsHeader";
import TopDebtorsTable from "./TopDebtorsTable";
import TopDebtorsRowsSkeleton from "./TopDebtorsRowsSkeleton";
import TopDebtorsTableToggleButton from "./TopDebtorsTableToggleButton";
import PortfolioAgingSkeleton from "./PortfolioAgingSkeleton";

function PortfolioAgingScreen() {
    const application = useApplication();
    const navigator = useNavigate();
    const theme = useTheme();
    const feature = useNavigatorFeature(() => new PortfolioAgingFeature(application, navigator), navigator);

    if (!feature) {
        return null;
    }

    if (!feature.loaded) {
        return <PortfolioAgingSkeleton/>;
    }

    const tiersWithColor = feature.presentedTiers().map((tier, tierIndex) => ({...tier, color: theme.brand.agingRamp[tierIndex]}));
    const selectedTier = tiersWithColor.find(tier => tier.selected);
    const selectedTierColor = selectedTier ? selectedTier.color : theme.brand.agingRamp[0];
    const debtors = feature.presentedTopDebtors();
    const selectedTierLabel = feature.selectedTierLabel();
    const selectedTierCustomersCount = feature.selectedTierCustomersCount();
    const selectedTierTotal = feature.selectedTierTotal();
    const topDebtorsLoading = feature.topDebtorsLoading;

    return (
        <Box sx={{marginBottom: 3}}>
            <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 1}}>
                <Typography variant="h6">Aging de deuda</Typography>
                <TopDebtorsTableToggleButton open={feature.topDebtorsTableOpen}
                                             onClick={() => feature.toggleTopDebtorsTable()}/>
            </Box>
            <StackedAgingBar tiers={tiersWithColor}/>
            <Box sx={{display: 'grid', gridTemplateColumns: `repeat(${tiersWithColor.length}, minmax(0, 1fr))`,
                gap: 1, marginBottom: 3}}>
                {tiersWithColor.map(tier => (
                    <AgingTierCard key={tier.code} tier={tier} onClick={() => feature.selectTier(tier.code)}/>
                ))}
            </Box>
            <Collapse in={feature.topDebtorsTableOpen}>
                <TopDebtorsHeader tierLabel={selectedTierLabel} customersCount={selectedTierCustomersCount}
                                 tierTotal={selectedTierTotal} tierColor={selectedTierColor} loading={topDebtorsLoading}/>
                {topDebtorsLoading
                    ? <TopDebtorsRowsSkeleton/>
                    : <TopDebtorsTable debtors={debtors} onNavigateToCustomer={businessName => feature.navigateToCurrentAccountScreen(businessName)}/>}
            </Collapse>
        </Box>
    );
}

export default observer(PortfolioAgingScreen)
